module.exports = __webpack_public_path__ + "img/placemark.43e2c3be.svg";